/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class claimcontract extends IceEntity {
  claim_contract_key: string = "";
  contract_type_code: string = "";
  price: number = 0.0;
  percentage: number = 0.0;
  contract_code: string = "";
  terms_discount_percentage: number = 0.0;
  version_identifier: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
  return "CLAIM_CONTRACT";
  }
}


